import Chart from "chart.js/auto";

export default function barChart() {
    Alpine.data('barChart', () => ({
        chartData: {},
        currentView: 0,
        chart: null,
        processData(string) {
            this.chartData = string;
            this.renderChart()
        },
        renderChart(mode, number) {
            let delayed;
            const ctx = document.getElementById('myChart');
            if(mode === 'update'){
                this.currentView = number;
                this.chart.data.datasets[0].data = this.chartData[this.currentView].values;
                this.chart.data.labels = this.chartData[this.currentView].labels;
                this.chart.update();
            }else {
                if(this.chart == null){
                    const chartObj = new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: this.chartData[this.currentView].labels,
                            datasets: [{
                                data: this.chartData[this.currentView].values,
                                backgroundColor: [
                                    '#006DFF',
                                    '#FA4692',
                                    '#000F8F'
                                ],
                            }]
                        },
                        options: {
                            animation: {
                                onComplete: () => {
                                    delayed = true;
                                },
                                delay: (context) => {
                                    let delay = 0;
                                    if (context.type === 'data' && context.mode === 'default' && !delayed) {
                                        delay = context.dataIndex * 100 + context.datasetIndex * 50;
                                    }
                                    return delay;
                                },
                            },
                            responsive: true,
                            indexAxis: 'y',
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    display: false
                                },
                                tooltip: {
                                    boxPadding: 6,
                                }
                            },
                            scales: {
                                y: {
                                    ticks: {
                                        font: {
                                            weight: 'bold',
                                        },
                                        color: 'black',
                                        display: function(context) {
                                            return window.innerWidth > 600;
                                        }
                                    },
                                    grid: {
                                        display: false,
                                    }
                                },
                                x:{
                                    ticks:{
                                        callback: function(value) {
                                            return value + '%';
                                        }
                                    }
                                }
                            }
                        }
                    });
                    Object.seal(chartObj);
                    this.chart = chartObj;
                }
            }
        }
    }));
}